import React from 'react';
import { baseConfig } from '../../config';

const Logo = () => {
  return <>{baseConfig.logo}</>;
};

export default Logo;
